import { FETCH_METHODS, SearchConfig } from "../api.model"
import { DataTableSchema, TableColumnSchema } from "../dynamic-data-table.model"
import { BrandDropdown, DealerDropdown, DefaultNumber, defaultSearchContainerButtons, EmpStatusDropdown, FieldNames, FirstNameText, LastNameText, SpinIdNumber } from "../form-fields.model";
import { ButtonFieldConfig, DisplayTranformation, DynamicFormArray, FormFieldConfig, Props } from "../form.model"
import { TenureAreaOptions, tenureAreaRegionField, TenureDefaultTableSchema, TenureTitle } from "../tenure.model";

const BrandTenureFilterField:FormFieldConfig = {
  ...structuredClone(DefaultNumber),
  fieldName: FieldNames['Tenure'],
  displayName: 'Dealer Tenure',
  fieldCriteriaConfig: {
    operators:[
      {value:'less than', label: 'Less than', title: 'Less Than'},
      {value:'greater than', label: 'Greater than', title: 'Greater Than'},
      {value:'equal to', label: 'Equal to', title: 'Equal to'}
    ],
    value:'equal to'
  }
} 
export const DealerTenureHistory = 'dealer_tenure_history'


const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, BrandDropdown,
    {...structuredClone(tenureAreaRegionField),multiple:true, options:TenureAreaOptions},
    {...structuredClone(DealerDropdown),fieldName:FieldNames['DealerCode'], displayName: 'Dealer Code / Dealer Name', options:[], displayTranformation: DisplayTranformation.none, isAutoComplete:true},   FirstNameText, LastNameText,EmpStatusDropdown, BrandTenureFilterField
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const DealerTenureHistorySearchConfig:SearchConfig = {
  method: "POST",
  path: "getTenureHistory",
  body:{
    [FieldNames['SpinId']]: '',
    brand: '',
    "type": "dealer",
    dealerCode:''
  }
}

const columnSchema: Array<TableColumnSchema> = [
  {
    label: 'Actions', fieldKey: 'brand_tenure_actions', fieldType: 'Actions', actionConfig: [
    {
      fieldKey: DealerTenureHistory,
      iconClass: 'fa-solid fa-clock-rotate-left',
      toolTip: 'History'
    }]
  },
  { label: "SPIN ID", fieldKey: 'spinId' },
  { label: "FIRST NAME", fieldKey: 'firstName' },
  { label: "LAST NAME", fieldKey: 'lastName' },
  { label: "EMAIL", fieldKey: 'email' },
  { label: "EMPLOYEE STATUS", fieldKey: 'employeeStatus' },
  { label: "Brand", fieldKey: 'brand' },
  { label: "DEALER", fieldKey: 'dealerCode' },
  { label: "DEALER NAME", fieldKey: 'dealerName' },
  { label: "Actual Dealer Tenure", fieldKey: 'actualTenureOverall', isCamelCaseHeader:true },
  { label: "Adjusted Dealer Tenure", fieldKey: 'adjustedTenureOverall' , isCamelCaseHeader: true },
  { label: "Total Tenure", fieldKey: 'dealerTenure' , isCamelCaseHeader: true }
]

export const DealerTenureTitle = 'Dealers Tenure'

export const DealerTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getDealerTenure",
  body: {
    "area": "",
    "spinId": "",
    "firstName": "",
    "lastName": "",
    "EmployeeStatus": "",
    "Brand": "",
    "type": "BRAND"
  }
}

export const DealerTenureFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: DealerTenureSearchConfig,
}

export const DealerTenureTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  columnSchema: columnSchema,
  exportConfig:{
    fileName: 'dealer_tenure',
    exportMessage:'Dealer Tenure data'
  },
  breadcrums: [{ level: 1, name: TenureTitle },{ level: 2, name: DealerTenureTitle }]
}

export const note: Array<any> = [
    'Tenure displayed in Months'
]

export const DealerTenureProps: Props = {
  isBreadCrumbSection: true,
  optionExplanation: note,
}